<template>
  <button
    v-tooltip.top="`Italic`"
    class="border rounded px-2 py-1 flex items-center h-8 cursor-pointer hover:bg-gray-100 bg-white"
    @click="editor.chain().focus().toggleItalic().run()"
  >
    <Icon
      class="h-[20px] w-[20px]"
      name="material-symbols:format-italic-rounded"
    />
  </button>
</template>

<script setup lang="ts">
const editor = defineModel('editor')
</script>
